module.exports = __webpack_public_path__ + "img/charity-5.71370ff3.png";